import React from "react";
import Render from "@gqlapp/theme";
import template from "./list.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import { fetchMenu, fetchList } from "@lib/content/fetch";
import { cleanPath, toTeasers } from "@lib/content/normalize";
import { buildPager, currentPage } from "@lib/content/pager";
import ARTICLES_QUERY from "@modules/article/graphql/ArticlesQuery.graphql";

const PAGE_SIZE = 20;
const EMPTY = { title: '', items: [], pager: [], categories: [] };

export default function ListContainer(props: any){
	const { articleListData } = props;
	return <>
		<Render {...{ template, context: { partials: { ...sharedPartials }, ...EMPTY, ...(articleListData || {}) } }} />
	</>;
}

ListContainer.getInitialProps = async (ctx: any) => {
	const { apolloClient } = ctx || {};
	const id = Number(ctx?.graphqlRoute?.id);
	const page = currentPage(ctx?.query);
	const basePath = cleanPath(ctx?.path);
	const title = ctx?.graphqlRoute?.title || '';

	try {
		const [list, categories] = await Promise.all([
			id > 0
				? fetchList(apolloClient, ARTICLES_QUERY, { page, pageSize: PAGE_SIZE, filter: { tids: [id] } })
				: Promise.resolve({ edges: [], total: 0 }),
			fetchMenu(apolloClient, 'article'),
		]);
		return { articleListData: { title, items: toTeasers(list.edges), pager: buildPager({ basePath, page, total: list.total, pageSize: PAGE_SIZE }), categories } };
	} catch (e) {
		debug(e);
		return { articleListData: { ...EMPTY, title } };
	}
};
